import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[numbersOnly]',
  standalone: true,
})
export class NumberDirective {
  constructor(private _el: ElementRef) {}

  @HostListener('keydown', ['$event']) onKeyDown(event: {
    key: string;
    ctrlKey: boolean;
    metaKey: boolean;
    preventDefault: () => void;
  }) {
    if (
      // Allow: Delete, Backspace, Tab, Escape, Enter, etc
      event.key === 'ArrowUp' || // Allow: Ctrl+A
      event.key === 'ArrowDown' || // Allow: Ctrl+A
      event.key === 'ArrowLeft' || // Allow: Ctrl+A
      event.key === 'ArrowRight' || // Allow: Ctrl+A
      event.key === 'Backspace' || // Allow: Ctrl+A
      event.key === 'Delete' || // Allow: Ctrl+A
      event.key === 'Tab' || // Allow: Ctrl+A
      (event.key === 'a' && event.ctrlKey === true) || // Allow: Ctrl+A
      (event.key === 'c' && event.ctrlKey === true) || // Allow: Ctrl+C
      (event.key === 'v' && event.ctrlKey === true) || // Allow: Ctrl+V
      (event.key === 'x' && event.ctrlKey === true) || // Allow: Ctrl+X
      (event.key === 'a' && event.metaKey === true) || // Cmd+A (Mac)
      (event.key === 'c' && event.metaKey === true) || // Cmd+C (Mac)
      (event.key === 'v' && event.metaKey === true) || // Cmd+V (Mac)
      (event.key === 'x' && event.metaKey === true) // Cmd+X (Mac)
    ) {
      return; // let it happen, don't do anything
    }

    if (event.key === ' ' || isNaN(Number(event.key))) {
      event.preventDefault();
    }
  }
}
